// extracted by mini-css-extract-plugin
module.exports = {"addFormWrapper":"Translations_addFormWrapper__19Zdb","deleteBtn":"Translations_deleteBtn__tUEHO","fixedButtons":"Translations_fixedButtons__hqTdl"};